export const getters = {
  uncubesServerReady: (state) => state.uncubesServerReady,
  kpiStorage: (state) => (kpiType) => (key) => state.kpiStorage.find((kpi) => kpi.kpiType === kpiType && kpi.key === key) || { kpi: 0.0, increment: 0.0, default: true }
};
